import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import AnnotViewer from "@/components/dms/AnnotViewer";

/**
 * PdfViewer – Kompatibilitäts-Wrapper um den neuen AnnotViewer (Markierungstools).
 * - mode="modal" (default): zentriertes Dialog
 * - mode="inline": komplettes Panel (z. B. rechte Spalte im Split-View)
 */
export default function PdfViewer({ open = true, onClose, dokumentId, akteId, dokumentName, contentType, mode = "modal", onMarkerChange }) {
  if (mode === "inline") {
    return (
      <div className="flex-1 flex min-h-[60vh] border border-[#E5E7EB] rounded-lg overflow-hidden" data-testid="pdf-viewer-body">
        <AnnotViewer dokumentId={dokumentId} akteId={akteId} dokumentName={dokumentName} contentType={contentType} onClose={onClose} onMarkerChange={onMarkerChange} />
      </div>
    );
  }
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[1500px] w-[96vw] h-[94vh] p-0 overflow-hidden flex flex-col gap-0 [&>button]:hidden" aria-describedby={undefined} data-testid="pdf-viewer-dialog">
        <DialogHeader className="sr-only">
          <DialogTitle>{dokumentName || "Dokument"}</DialogTitle>
        </DialogHeader>
        <div className="px-4 py-2 border-b border-[#E5E7EB] flex items-center gap-3 shrink-0">
          <p className="font-serif text-lg truncate flex-1" data-testid="pdf-viewer-title">{dokumentName || "Dokument"}</p>
        </div>
        {dokumentId && (
          <div className="flex-1 min-h-0 flex" data-testid="pdf-viewer-body">
            <AnnotViewer dokumentId={dokumentId} akteId={akteId} dokumentName={dokumentName} contentType={contentType} onClose={onClose} onMarkerChange={onMarkerChange} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
